new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#footer',
    data: {
        activeInfos: false,
        activeContact: false,
        activeCaller: false,
    },
    methods: {
        toggleTab(tab) {
            this.activeInfos = false;
            this.activeContact = false;
            this.activeCaller = false;
            
            switch(tab) {
                case 1:
                    this.activeInfos = true;
                    break;
                case 2:
                    this.activeContact = true;
                    break;
                case 3:
                    this.activeCaller = true;
                    break;
                default:
                    break;
            }
        }
    }
})